import React from 'react';

import type { MyTISectionHeaderProps } from './interfaces';

const MyTISectionHeader = ({ highlight, subtitle, title }: MyTISectionHeaderProps) => {
  if (!highlight && !subtitle && !title) {
    return null;
  }

  return (
    <header>
      <span className="block font-suisse-intl-mono text-caption-lg font-normal text-primary-magenta">
        {highlight}
      </span>
      <h2 className="m-0 font-suisse-screen text-headline-sm text-grayscale-charcoal sm:text-headline-lg">
        {title}
      </h2>
      <p className="mb-0 mt-8 font-suisse-neue text-body-lg sm:text-subheadline-sm">{subtitle}</p>
    </header>
  );
};

export default MyTISectionHeader;
